const baseURL = 'https://empresa.sociospro.com';

export default baseURL;
